export const formQuestions = [{
        additionalClass: "",
        fields: [{
            label: "What type of work experience did you do?",
            name: "expType",
            type: "typeRadio",
            required: true,
            options: [
                "Work experience",
                "Paid employment",
                "Volunteering",
                "Other career exploration activity"
            ]
        }]
    },
    {
        additionalClass: "",
        fields: [{
            label: "Name of company, organisation or event",
            name: "expName",
            type: "text",
            placeholder: "e.g. Bob's burgers",
            required: true,
            maxlength: 100
        }]
    },
    {
        additionalClass: "group-row",
        fields: [{
                label: "Hours completed",
                name: "hoursCompleted",
                type: "timeCapture",
                required: true,
                placeholder: "01:00"
            },
            {
                label: "Start date",
                name: "startDate",
                type: "date",
                required: true,
                value: "2021-05-05T08:55:59Z",

            },
            {
                label: "End date",
                name: "endDate",
                type: "date",
                required: true,
                value: "2021-07-22T08:55:59Z"
            }
        ]
    },
    {
        additionalClass: "",
        fields: [{
            label: "Rate your experience",
            name: "rating",
            type: "radioCustomIconLabel",
            required: true,
            options: [{
                    text: "Good",
                    icon: 'fa-smile'
                },
                {
                    text: "Neutral",
                    icon: 'fa-meh'
                },
                {
                    text: "Bad",
                    icon: 'fa-frown'
                },
            ]
        }]
    },
    {
        additionalClass: "",
        fields: [{
            label: "What did you learn?",
            note: "Take some time to reflect on your experience. What did you learn? Has it helped you decide what you might like to do as a job? Remember, there is no right or wrong answer. This is about you discovering things you enjoy!(max 1500 characters)",
            name: "lessonsLearned",
            type: "textarea",
            placeholder: "Type here...",
            maxlength: 1500,
            required: true,
        }]
    },
    {
        additionalClass: "",
        fields: [{
            label: "Would you like to add this to your ePortfolio?",
            name: "ePortfolio",
            type: "checkbox",
            required: false,
            options: [
                "Yes, add this to my ePortfolio"
            ],
            additionalQuestionClass: "hidden"
        }]
    }
]

export const testData = {
    expName: "Moore Wilsons",
    expType: ["Part-time job"],
    hoursCompleted: 119,
    startDate: "2021-02-10T08:55:59Z",
    endDate: "2021-02-10T08:55:59Z",
    rating: "Bad",
    lessonsLearned: "I liked it alot. Learnt stuff",
    ePortfolio: []
}

export const emptyData = {
    expName: "",
    expType: [],
    hoursCompleted: 0,
    startDate: "",
    endDate: "",
    rating: "",
    lessonsLearned: "",
    ePortfolio: []
}

export const testListData = [{
        expName: "Moore Wilsons",
        expType: ["Part-time job"],
        hoursCompleted: 119,
        startDate: "2021-02-10T08:55:59Z",
        endDate: "2021-02-10T08:55:59Z",
        rating: "Bad",
        lessonsLearned: "I liked it alot. Learnt stuff",
        ePortfolio: []
    },
    {
        expName: "Disneyland",
        expType: ["Work experience", "Volunteering"],
        hoursCompleted: 123,
        startDate: "2021-02-10T08:55:59Z",
        endDate: "2021-02-10T08:55:59Z",
        rating: "Neutral",
        lessonsLearned: "Don't trust Goofy. He is sketch af",
        ePortfolio: []
    },
    {
        expName: "Fortune teller",
        expType: ["Career expo"],
        hoursCompleted: 20,
        startDate: "2045-02-10T08:55:59Z",
        endDate: "2045-11-23T08:55:59Z",
        rating: "Good",
        lessonsLearned: "The future is amaze. I've said too much",
        ePortfolio: []
    }
]

export const RATING_ICON = {
    "good": 'fa-smile',
    "neutral": 'fa-meh',
    "bad": 'fa-frown'
}